export default __webpack_public_path__ + "static/media/about-thumb.ee3f6532.png";